const ArticlePredefinedOptionType = {
  /**
   * There are 2 message where this is used.
   * 1. In article list navigation message
   * 2. In pre support prompt message when Explore articles is selected.
   */
  BROWSE_OTHER_ARTICLES: 'static.option.browser_other_articles',
  ISSUE_NOT_LISTED: 'static.option.issue_not_listed',
} as const;

const AlternativeActionsPredefinedOptionType = {
  RESTART_CHAT: 'static.action.restart_chat',
  END_CHAT: 'static.action.end_chat',
  GO_TO_TICKET: 'static.action.go_to_ticket',
  CONNECT_TO_SUPPORT: 'static.action.connect_to_support',
  SEARCH_ARTICLES: 'static.action.search_articles',
  NEED_MORE_HELP: 'static.action.need_more_help',
} as const;
export const PredefinedOptionType = {
  ...ArticlePredefinedOptionType,
  ...AlternativeActionsPredefinedOptionType,
  POSITIVE_RESOLUTION: 'static.option.yes',
  NO_OTHER_ISSUE: 'static.option.no_other_issue',
} as const;

export type PredefinedOptionKind = (typeof PredefinedOptionType)[keyof typeof PredefinedOptionType];
export type PredefinedArticleNavigationOptions =
  (typeof ArticlePredefinedOptionType)[keyof typeof ArticlePredefinedOptionType];
export type PredefinedAltActionOptions =
  (typeof AlternativeActionsPredefinedOptionType)[keyof typeof AlternativeActionsPredefinedOptionType];
export type PredefinedPreSupportOptions =
  | PredefinedAltActionOptions
  | typeof PredefinedOptionType.BROWSE_OTHER_ARTICLES
  | typeof PredefinedOptionType.POSITIVE_RESOLUTION
  | typeof PredefinedOptionType.NO_OTHER_ISSUE;
